// TODO mb use lodash/arrays here?
const arrayUtils = {
  pushOrRemove: <T>(array: T[], element: T): void => {
    const found = array.findIndex(selected => selected === element);

    if (found === -1) {
      array.push(element);
    } else {
      array.splice(found, 1);
    }
  },
  remove: <T>(array: T[], element: T): void => {
    const found = array.findIndex(selected => selected === element);

    if (found !== -1) {
      array.splice(found, 1);
    }
  },
  has: <T>(array: T[], element: T): boolean => {
    const found = array.findIndex(selected => selected === element);

    return found !== -1;
  },
  removeAllOccurrences: <T>(baseArray: T[], elementsToRemove: T[]): void => {
    elementsToRemove.forEach(toRemove => {
      arrayUtils.remove(baseArray, toRemove);
    });
  },
  removeDuplicates: <T>(array: T[]): T[] => {
    const set = new Set(array);

    return Array.from(set);
  },
  mergeAsUnion: <T>(first: T[], second: T[]): T[] => {
    return arrayUtils.removeDuplicates([...first, ...second]);
  },
  isArraysEqual: <T>(first: T[], second: T[]) => {
    return first.toString() === second.toString();
  },
};

export { arrayUtils };
